
const config = {
    sso: {
        loginUrl: 'https://apps.salicru.com',
        legacyAuthUrl: 'undefined',
        appName: 'products-homepage',
        portalAuthUrl: 'https://auth.apps.salicru.com',
        cookieName: 'apps-token'
    }
};

export default config;
